module.exports = __webpack_public_path__ + "img/qu_us.0eae85c.jpg";